import { render, staticRenderFns } from "./SimilarProductsTab.vue?vue&type=template&id=4662852d&"
import script from "./SimilarProductsTab.vue?vue&type=script&lang=ts&"
export * from "./SimilarProductsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports